const createImageAsync = async (
    imageSource: string,
): Promise<HTMLImageElement> =>
    new Promise((resolve, reject) => {
        const image = new Image();
        image.addEventListener("load", () => resolve(image));
        image.addEventListener("error", (error) =>
            reject(new Error(`Failed to load image: ${error}`)),
        );
        image.setAttribute("crossOrigin", "anonymous");
        image.src = imageSource;
    });

const convertCanvasToDataUrlAsync = async (
    canvas: HTMLCanvasElement,
    mimeType = "image/jpeg",
    quality = 1.0,
): Promise<string> =>
    new Promise((resolve, reject) => {
        try {
            const dataUrl = canvas.toDataURL(mimeType, quality);
            resolve(dataUrl);
        } catch (error) {
            reject(new Error(`Error converting canvas to Data URL: ${error}`));
        }
    });

export const getCroppedImg = async (
    imageSource: string,
    pixelCrop: { x: number; y: number; width: number; height: number },
): Promise<string> => {
    const image = await createImageAsync(imageSource);
    const cropCanvas = document.createElement("canvas");
    const cropContext = cropCanvas.getContext("2d");

    if (!cropContext) {
        throw new Error("No 2d context");
    }

    cropCanvas.width = pixelCrop.width;
    cropCanvas.height = pixelCrop.height;
    cropContext.drawImage(
        image,
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height,
        0,
        0,
        pixelCrop.width,
        pixelCrop.height,
    );

    // const resizedCanvas = resizeImage(cropCanvas, 480, 480);
    return convertCanvasToDataUrlAsync(cropCanvas);
};
